const getWeightUnits = () => ({ KG: 'KG' });

const getVolumeUnits = () => ({ CFT: 'CFT' });

const getVolumeDimensionsUnits = () => ({ MM: 'MM', CM: 'CM', IN: 'IN', FT: 'FT', YD: 'YD', M: 'M' });

const getHeightUnits = () => getVolumeDimensionsUnits();

const getWidthUnits = () => getVolumeDimensionsUnits();

const getLengthUnits = () => getVolumeDimensionsUnits();

const acrossMaterialUploadChunkSize = 2000;
const materialInvoiceGrnUploadChunkSize = 2000;

const quantityUnitsForPieces = {
  pce: 'pieces',
  no: 'pieces',
  pcs: 'pieces',
  each: 'pieces',
  ea: 'pieces',
  pieces: 'pieces',
  it: 'pieces',
  pc: 'pieces',
  ECH: 'pieces',
  ech: 'pieces'
};

const Material = {
  validHeader: {
    Code: 'code',
    Name: 'name',
    BU: 'bu',
    Division: 'division',
    'Piece per Box': 'piece_box',
    'Length(cm)': 'box_length',
    'Width(cm)': 'box_width',
    'Height (cm)': 'box_height',
    'Weight (kg)': 'box_weight',
    'Volume (CFT)': 'box_volume',
    'GST Exempt (Yes/No)': 'gst_exempt',
    Category: 'category',
  },
  exportAndRejectionHeaders: {
    'Code*': 'code',
    'Name*': 'name',
    BU: 'bu',
    Division: 'division',
    'Piece per Box*': 'piece_box',
    'Length(cm)*': 'box_length',
    'Width(cm)*': 'box_width',
    'Height (cm)*': 'box_height',
    'Weight (kg)*': 'box_weight',
    'Volume (CFT)': 'box_volume',
    'GST Exempt (Yes/No)': 'gst_exempt',
    Category: 'category',
  },
  nonMandatoryValidHeader: {
    'Volume Per Piece (Liter)': 'volume_per_piece',
    Pallets: 'pallets',
    Brand: 'brand',
    'Sub Brand': 'sub_brand',
    Thickness: 'thickness',
    'Load Sequence': 'load_sequence',
    'Can Telescope (Yes/No)': 'can_telescope',
  },
  validAssociatedMaterialHeader: {
    'Parent Material Code': 'parentMaterialCode',
    'Child Material Code': 'childMaterialCode',
    'Parent Fraction': 'parentFraction',
    'Child Fraction': 'childFraction',
  },

  quantityUnits: {
    'c/s': 'cases',
    's/o': 'cases',
    cs: 'cases',
    box: 'cases',
    boxes: 'cases',
    pkg: 'cases',
    pkgs: 'cases',
    cases: 'cases',
    case: 'cases',
    nos: 'cases',
    pce: 'pieces',
    no: 'pieces',
    pcs: 'pieces',
    bags: 'cases',
    each: 'pieces',
    ea: 'pieces',
    pieces: 'pieces',
    kar: 'cases',
    ctn: 'cases',
    st: 'cases',
    it: 'pieces',
    kg: 'cases',
    kgs: 'cases',
    lt: 'cases',
    lts: 'cases',
    litre: 'cases',
    litres: 'cases',
    pc: 'pieces',
    PC: 'pieces',
    CV: 'cases',
    cv: 'cases',
    PAC: 'pieces',
    pac: 'pieces',
    ECH: 'pieces',
    ech: 'pieces'
  },
  epodQuantityUnits: {
    'c/s': 'cases',
    's/o': 'cases',
    cs: 'cases',
    box: 'cases',
    boxes: 'cases',
    pkg: 'cases',
    pkgs: 'cases',
    cases: 'cases',
    case: 'cases',
    nos: 'cases',
    pce: 'pieces',
    no: 'pieces',
    pcs: 'pieces',
    bags: 'cases',
    each: 'pieces',
    ea: 'pieces',
    pieces: 'pieces',
    kar: 'cases',
    ctn: 'cases',
    st: 'cases',
    mt: 'mt',
    kg: 'kg',
    it: 'pieces',
    pc: 'pieces',
    PC: 'pieces',
    CV: 'cases',
    cv: 'cases',
    PAC: 'pieces',
    pac: 'pieces',
    ECH: 'pieces',
    ech: 'pieces'
  },
  quantityUnitsForDMS: {
    pieces: 'pcs',
  },
  validationLabel: {
    BOX_HEIGHT: 'Height',
    BOX_LENGTH: 'Length',
    BOX_WIDTH: 'Width',
    BOX_WEIGHT: 'Weight',
    PIECE_BOX: 'Piece / Box',
    VOLUME: 'Volume',
    VOLUME_PER_PIECE: 'Volume Per Piece',
  },
};

const getTypesOfQuantityConversion = () => ({ PIECES_TO_BOXES: 'PIECES_TO_BOXES', BOXES_TO_PIECES: 'BOXES_TO_PIECES' });

const MaterialUserAssociateHeader = {
  'Material Code': 'material_code',
  Users: 'user_email',
};

const ExportMaterials = 'export_material';

module.exports = {
  getWeightUnits,
  getVolumeUnits,
  getHeightUnits,
  getWidthUnits,
  getLengthUnits,
  acrossMaterialUploadChunkSize,
  materialInvoiceGrnUploadChunkSize,
  quantityUnitsForPieces,
  getTypesOfQuantityConversion,
  Material,
  MaterialUserAssociateHeader,
  ExportMaterials,
};
